module.exports = __webpack_public_path__ + "img/image-thumb-13.35639eeb.jpg";